// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner__Loader__3dgUo","load6":"Spinner__load6__3Ebkm","round":"Spinner__round__2-YqU"};